import { Injectable } from "@angular/core";
import { CRMActivityDefinitionConnector } from "./crm-activity-definition.connector";
import { AuthenticationService, CachingService, IAMService, UIService } from "src/app/services/services.module";
import { ActivityDefinitionDocument, APIResponse } from "server-model";
import { AppServerCRMActivityDefinitionConnector } from "../../app-server-connectors";

@Injectable()
export class CRMActivityDefintionDataService {
    private crmActivityDefinitionConnector: CRMActivityDefinitionConnector;

    constructor(
        private cachingService: CachingService,
        private iamService: IAMService,
        private authenticationService: AuthenticationService,
        private uiService: UIService,
    ) {
        this.crmActivityDefinitionConnector = new AppServerCRMActivityDefinitionConnector(this.iamService, this.authenticationService, this.uiService)
    }

    async getActivityDefinition(activityName: string, organisationId: string): Promise<APIResponse> {
        const response = await this.crmActivityDefinitionConnector.getActivityDefinition(activityName,organisationId);
        return response;
    }

    async listActivityDefinition(organisationId: string): Promise<APIResponse> {
        const response = await this.crmActivityDefinitionConnector.listActivityDefinition(organisationId);
        return response;
    }

    async createActivityDefinition(activityDefinitionDocument: ActivityDefinitionDocument): Promise<APIResponse> {
        const response = await this.crmActivityDefinitionConnector.createActivityDefinition(activityDefinitionDocument);
        return response;
    }

    async updateActivityDefinition(activityName: string, organisationId: string, activityDefinitionDocument: ActivityDefinitionDocument): Promise<APIResponse> {
        const response = await this.crmActivityDefinitionConnector.updateActivityDefinition(activityName, organisationId, activityDefinitionDocument);
        return response;
    }

    async deleteActivityDefinition(activityName: string, organisationId: string): Promise<APIResponse> {
        const response = await this.crmActivityDefinitionConnector.deleteActivityDefinition(activityName, organisationId);
        return response;
    }
}
